module.exports = __webpack_public_path__ + "img/banner-1.185a1060.jpg";